/* eslint camelcase: 0 */

import { Roadmap as Data } from '@/typings/api/Roadmap'
import { Model, createMessages } from '@/helpers/Model'


export class RoadmapModel extends Model<Data> {
  public static readonly page_title = createMessages({
    create: 'Добавить дорожную карту',
    edit: 'Редактировать дорожную карту',
    view: (data: RoadmapModel) => 'Дорожная карта «{name}»'
      .replace('{name}', data.name || '...'),
    list: 'Дорожные карты',
  });

  public static readonly modal_delete = createMessages({
    delete: (data: RoadmapModel) => 'Удаление дорожной карты «{name}»'
      .replace('{name}', data.name || '...'),
    delete_all: 'Удаление выбранных дорожных карт',
    delete_all_partly: 'Удаление части выбранных дорожных карт',
  });

  public static readonly response_success = createMessages({
    ...Model.response_success,
    delete_all_deny: 'Выбранные дорожные карты нельзя удалить',
  });

  public static readonly response_error = createMessages({
    ...Model.response_error,
  });
}
